// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SystemMessageLayout__container-f41ca1 {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.SystemMessageLayout__select-label-d37e52 {
  top: 0;
}

.SystemMessageLayout__container-f41ca1 .SystemMessageLayout__system-message-menu-c95e6a {
  padding-top: 0;
}

.SystemMessageLayout__menu-placeholder-fbe6f8 {
  min-height: 36px;
  min-width: 140px;
}

.SystemMessageLayout__inner-container-e18e6a {
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/SystemMessageLayout/SystemMessageLayout.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,MAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF","sourcesContent":[".container {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n\n.select-label {\n  top: 0;\n}\n\n.container .system-message-menu {\n  padding-top: 0;\n}\n\n.menu-placeholder {\n  min-height: 36px;\n  min-width: 140px;\n}\n\n.inner-container {\n  display: flex;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SystemMessageLayout__container-f41ca1`,
	"select-label": `SystemMessageLayout__select-label-d37e52`,
	"selectLabel": `SystemMessageLayout__select-label-d37e52`,
	"system-message-menu": `SystemMessageLayout__system-message-menu-c95e6a`,
	"systemMessageMenu": `SystemMessageLayout__system-message-menu-c95e6a`,
	"menu-placeholder": `SystemMessageLayout__menu-placeholder-fbe6f8`,
	"menuPlaceholder": `SystemMessageLayout__menu-placeholder-fbe6f8`,
	"inner-container": `SystemMessageLayout__inner-container-e18e6a`,
	"innerContainer": `SystemMessageLayout__inner-container-e18e6a`
};
module.exports = ___CSS_LOADER_EXPORT___;
